import { render, staticRenderFns } from "./DomainSearchComponent.vue?vue&type=template&id=70644388&scoped=true&"
import script from "./DomainSearchComponent.vue?vue&type=script&lang=js&"
export * from "./DomainSearchComponent.vue?vue&type=script&lang=js&"
import style0 from "./DomainSearchComponent.vue?vue&type=style&index=0&id=70644388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70644388",
  null
  
)

export default component.exports